export default __webpack_public_path__ + "311cf24a7acc2902e92e07730e34a2f8.svg";